import React from 'react';
import { motion } from 'framer-motion';
import { Mic, Repeat, ShieldCheck } from 'lucide-react';
export function MethodReveal() {
  const steps = [{
    icon: <Mic className="w-8 h-8 text-white" data-id="element-115" />,
    title: '1) DI',
    desc: '10 frases listas (guion) para situaciones específicas.',
    color: 'bg-orange-500'
  }, {
    icon: <Repeat className="w-8 h-8 text-white" data-id="element-116" />,
    title: '2) REPITE',
    desc: '3 minutos de shadowing para que tu boca se suelte.',
    color: 'bg-pink-500'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-white" data-id="element-117" />,
    title: '3) RESCATA',
    desc: 'Frases puente para cuando tu mente se apaga.',
    color: 'bg-purple-500'
  }];
  return <section className="py-24 bg-orange-50 px-4" data-id="element-118">
      <div className="max-w-5xl mx-auto" data-id="element-119">
        <div className="text-center mb-16" data-id="element-120">
          <span className="text-orange-600 font-bold tracking-wider uppercase text-sm" data-id="element-121">
            El Método
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mt-3 mb-6" data-id="element-122">
            3×10 “Di–Repite–Rescata”
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto" data-id="element-123">
            En lugar de estudiar “inglés” como algo infinito, vas a entrenar
            situaciones repetidas.
            <br data-id="element-124" />
            <span className="font-bold text-orange-600" data-id="element-125">
              Solo 10 minutos al día.
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-126">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-8 rounded-3xl shadow-xl border-b-4 border-gray-100 hover:-translate-y-2 transition-transform duration-300" data-id="element-127">
              <div className={`${step.color} w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-lg rotate-3`} data-id="element-128">
                {step.icon}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-129">
                {step.title}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-130">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-131">
          <p className="text-lg font-medium text-gray-500" data-id="element-132">
            Esto no es teoría bonita. Es un procedimiento.
          </p>
        </div>
      </div>
    </section>;
}